/* eslint-disable react/no-array-index-key */
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';
import TextField from 'components/forms/textField/TextField';
import { CustomDataFieldType } from 'models/CustomDataField';
import RadioGroupField from 'components/forms/radioGroupField/RadioGroupField';
import { typedValues } from 'utils/funcs';
import { DisplayPreArrivalFormField } from '../../PreArrivalFormTab.types';
import {
  AdditionalInfoContainer,
  PreviewDivider,
  PreviewRow,
} from '../PreviewPreArrivalForm.styles';

const AdditionalInformationSection = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();

  const customFields = watch('customFields') as Record<
    string,
    DisplayPreArrivalFormField
  >;
  const newCustomFields = watch('newCustomFields') as Record<
    string,
    DisplayPreArrivalFormField
  >;

  const allCustomFields = { ...customFields, ...newCustomFields } as Record<
    string,
    DisplayPreArrivalFormField
  >;

  const shouldShowSection =
    Object.keys(allCustomFields).length > 0 &&
    Object.values(allCustomFields).some((field) => field.isActive);

  if (!shouldShowSection) {
    return null;
  }

  return (
    <>
      <AdditionalInfoContainer data-testid="preview-additional-information-section">
        <h2>
          {t('pageAutomations.preArrivalForm.preview.additionalInfo.header')}
        </h2>

        {typedValues(allCustomFields).map((field, i) => {
          if (field.type === CustomDataFieldType.SINGLE_SELECT) {
            return (
              <PreviewRow key={`${field.uid}${i}`}>
                <RadioGroupField
                  colSmInput={12}
                  name={`preview.customFields[${i}]`}
                  containerClassName="horizontal-radio-group"
                  required={field.validation === 'REQUIRED'}
                  labelOnTop
                  label={field.name}
                  options={[
                    {
                      label: t('common.yes'),
                      value: 'YES',
                    },
                    {
                      label: t('common.no'),
                      value: 'NO',
                    },
                  ]}
                />
              </PreviewRow>
            );
          }

          return (
            <PreviewRow key={`${field.uid}${i}`}>
              <TextField
                name={`preview.customFields[${i}]`}
                required={field.validation === 'REQUIRED'}
                label={field.name}
                labelOnTop
                colSmInput={12}
              />
            </PreviewRow>
          );
        })}
      </AdditionalInfoContainer>
      <PreviewDivider />
    </>
  );
};

export default AdditionalInformationSection;
